import { render, staticRenderFns } from "./UserProfileCertificatesTab.vue?vue&type=template&id=ed4e982a&scoped=true"
import script from "./UserProfileCertificatesTab.vue?vue&type=script&lang=js"
export * from "./UserProfileCertificatesTab.vue?vue&type=script&lang=js"
import style0 from "./UserProfileCertificatesTab.vue?vue&type=style&index=0&id=ed4e982a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4e982a",
  null
  
)

export default component.exports